import { FeatureFlag } from '@/enums/feature-flag';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useFeatureFlagsReady } from '@/hooks/use-feature-flags-ready';

export function useApplicationsPageVisible() {
  const isReady = useFeatureFlagsReady();
  const hasExternalSamlIdp = useFeatureFlag(FeatureFlag.EXTERNAL_SAML_IDP);

  return isReady && !hasExternalSamlIdp;
}
